import ldsLogo from "../assets/companies/newLdsLogo.jpg";

export const leadershipOrg = {
  id: "lds",
  company: "The Church of Jesus Christ of Latter-day Saints",
  duration: "July 2018 — Present",
  current: true,
  link: "https://www.churchofjesuschrist.org/?lang=eng",
  logo: ldsLogo,
  title: "Leadership & Operations (Volunteer)",
};

export const leadershipRoles = [
  {
    id: "bishop",
    title: "Operations Manager / Chief Executive (Bishop)",
    duration: "February 2024 — Present",
    current: true,
    skills: "Crisis Management, HR, Financial Oversight",
    bullets: [
      "Directed all operations for a local organization, overseeing a diverse volunteer workforce and multiple departments.",
      "Managed welfare and philanthropic budgets, providing financial counseling and resource allocation to individuals in crisis.",
      "Led conflict resolution initiatives and provided high-stakes emotional and professional coaching to community members.",
    ],
  },
  {
    id: "clerk",
    title: "Information & Records Administrator (Ward Clerk)",
    duration: "November 2023 — January 2024",
    skills: "Data Integrity, Financial Auditing, Reporting",
    bullets: [
      "Managed organizational records, ensuring accuracy in data entry and compliance with global reporting standards.",
      "Administered local budget allocations, processed accounts payable/receivable, and conducted quarterly financial audits.",
      "Generated analytical reports to assist leadership in data-driven decision-making.",
    ],
  },
  {
    id: "ym",
    title: "Regional Youth Program Director (Stake Young Men Councilor)",
    duration: "December 2020 — September 2023",
    skills: "Strategic Planning, Project Management, Mentorship",
    bullets: [
      "Oversaw youth development programs for multiple local branches, impacting participants across the region.",
      "Coordinated large-scale regional events, including budget allocation, logistics, and risk management.",
      "Trained and mentored local-level advisors on curriculum implementation and leadership development.",
    ],
  },
  {
    id: "exec-sec",
    title: "Executive Operations Secretary (Ward Executive Secretary)",
    duration: "August 2018 — November 2020",
    skills: "Scheduling, Liaison, Confidentiality",
    bullets: [
      "Managed the executive calendar and coordinated high-level briefings for senior leadership.",
      "Acted as a primary liaison between stakeholders and executives to ensure streamlined communication and project follow-through.",
      "Handled sensitive, confidential data with a high degree of discretion and professional integrity.",
    ],
  },
  {
    id: "missionary",
    title: "Full-Time Volunteer Representative (Missionary)",
    duration: "June 2014 — June 2016",
    skills: "Sales, Cross-Cultural Communication, Self-Management",
    bullets: [
      "Executed daily outreach and strategic planning to meet organizational growth goals in a high-pressure, self-directed environment.",
      "Mastered language requirements and navigated diverse cultural landscapes to build community relationships.",
      "Facilitated weekly training workshops and mentored new representatives on interpersonal communication and goal-setting.",
    ],
  },
];
